import React, { ReactNode } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { JobCardContext } from 'src/common/contexts/JobCardContext';
import isIframe from 'src/common/isIframe';
import { GoogleTagManager, Tag } from 'src/components/GoogleTagManager';
import {
  SEO_PATH_EXPLORE,
  UTM_REFERRER,
} from 'src/modules/Opportunities/constants';
import { JobInterface } from 'src/modules/Opportunity/interface';
import { getExpApplyOnAppVariant } from 'src/modules/Unleash/Selectors';

import { CompactJobCardList } from './styles.sc';

type AlternateCardData = {
  isAlternateCard: boolean;
  renderAlternateCard: (index: number) => ReactNode;
};

const _QueryExploreJobsList: React.FC<
  React.PropsWithChildren<{
    opportunities: JobInterface[];
  }>
> = ({ opportunities }) => {
  const { pathname } = useRouter();
  const expApplyOnAppVariant = useSelector(getExpApplyOnAppVariant);

  const referrer =
    pathname === SEO_PATH_EXPLORE
      ? UTM_REFERRER.SITE
      : isIframe
      ? UTM_REFERRER.BLOG_IFRAME_JOB_LIST
      : UTM_REFERRER.EXPLORE;

  const modOpportunities = opportunities.slice() as Array<
    AlternateCardData | JobInterface
  >;

  return (
    <GoogleTagManager
      tag={['job-search-results_job-card_link-in-internal-search-and-query']}
    >
      {([jobLinkClassName]: Tag) => (
        <JobCardContext.Provider value={{ jobLinkClassName }}>
          {/* TODO: remove this when CompactJobCardList is migrated to TS
             //@ts-ignore */}
          <CompactJobCardList
            data-job-search-length={opportunities.length}
            opportunities={modOpportunities}
            shouldHighlighHotJobs={true}
            data-gtm-exp-apply-on-app={expApplyOnAppVariant}
            referrer={referrer}
          />
        </JobCardContext.Provider>
      )}
    </GoogleTagManager>
  );
};

export const QueryExploreJobsList = React.memo(_QueryExploreJobsList);
